import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from '../store/index'
import auth from '@/services/authService'
import { User } from '@/services/data'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/Index.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/Home.vue'),
    children: [
      {
        path: 'settings',
        name: 'settings',
        component: () => import('../views/Settings/Index.vue'),
        children: [
          {
            path: 'user',
            name: 'user',
            component: () => import('../views/Settings/UserSettings.vue')
          },
          {
            path: 'api',
            name: 'api',
            component: () => import('../views/Settings/ApiSettings.vue')
          },
          {
            path: 'app',
            name: 'app',
            component: () => import('../views/Settings/App.vue')
          },
          {
            path: 'account',
            name: 'account',
            component: () => import('../views/Settings/Account.vue')
          },
          {
            path: 'notifications',
            name: 'notifications',
            component: () => import('../views/Settings/Notifications.vue')
          },
          {
            path: 'logs',
            name: 'logs',
            component: () => import('../views/Settings/Log.vue')
          }
        ]
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('../views/Home/Dashboard.vue')
      },
      {
        path: 'device-detail',
        name: 'device-detail',
        component: () => import('../views/Home/DeviceDet.vue')
      }
    ]
  },
  {
    path: '/notfound',
    name: 'notfound',
    component: () => import('../views/Page404.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login/Login.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
